﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'vas-item',
    props: ['vas', 'index', 'vaslist'],
    data: () => ({
        show: false,
        popupWidth: 0,
        resolutionValue: 0,
        resolutionHigh: 0,
        resolutionLarge: 0,
        resolutionXLarge: 0,
        popupPosition: 0,
        popupLocation: 0,
        itemDescription: '',
        link: '',
        itemDescriptionLink: '',
        itemDescriptionLink: null,
        elementSize: null,
        notifyButtonValue: null,
        className: null,
        scrollLeft: null,
        divOffset: null,
        popupDetails: null,
        pointerDetails: null,
        popupValue: null,
        readMoreLabel: null,
        readMoreHereLabel: null,
    }),
   
    computed: 
    Object.assign(   
            mapState({
            vasLessAllowed: state => state.offeringpage.vasLessAllowed,
            selectedVases: state => state.offeringpage.vas.selectedVas
            }),
            mapGetters({
            selectedVAS: 'selectedVas',
            otherProducts: 'otherProducts',
            otherVariants: 'otherVariants',
            selectedProduct: 'selectedProduct',
            selectedVariant: 'selectedVariant',
                }),
        {
            hasLogo() {
                if (this.vas.logoImageUrl) return true;
                else return false;
                
            },
            
            computedImgurl() {
                if (this.vas.imageUrl === null || typeof(this.vas.imageUrl) === 'undefined' || this.vas.imageUrl === '') return 'https://placehold.it/300x500/767676/ffffff/?text=+';
                else return this.vas.imageUrl;
            },
            selected() {
                var tempres = false;
                var self = this;
                this.selectedVAS.forEach(function(v){
                    if (self.vas.code === v.code) tempres = true;
                });
                return tempres;
            },
            price() {
                var cost = 0;
                var selectedVas = this.selectedVAS.length;

                if (this.vas.price) {
                    cost =  parseFloat(this.vas.price);
                }
                if (this.selectedVariant) {
                    var currentPrice = parseFloat(this.selectedVariant.monthlyPrice);
                    for (let i = 0; i < this.otherVariants.length; i++) {
                        if (!this.selected && this.otherVariants[i].speedDown == this.selectedVariant.speedDown && parseInt(this.otherVariants[i].numberOfVas) == selectedVas + 1) {
                            let newPrice = parseFloat(this.otherVariants[i].monthlyPrice);
                            cost = cost + (newPrice - currentPrice);
                        } else if (this.selected && selectedVas > 1 && this.otherVariants[i].speedDown == this.selectedVariant.speedDown && parseInt(this.otherVariants[i].numberOfVas) == selectedVas - 1) {
                            let newPrice = parseFloat(this.otherVariants[i].monthlyPrice);
                            cost = cost + (newPrice - currentPrice);
                        }
                    }
                }

                return cost;
            }
        }),
        methods: {
            toggleSelect(index) {
                this.vas.pointer=index;
                if(this.selected) {
                    this.$store.dispatch('deselectVAS', this.vas)
                    
                }
                else {
                    this.$store.dispatch('selectVAS', this.vas);
                }
            
            },            
            notifypopup: function(index) {
                this.popupDetails =  document.getElementById("showpopup");
                this.pointerDetails =  document.getElementById("pointer");
                this.popupValue = document.getElementById("popupstyle");
                this.notifyButtonValue =  document.getElementById("notifybutton" + index);
                this.elementSize = this.notifyButtonValue.getBoundingClientRect(),
                this.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                this.divOffset =  this.elementSize.left + this.scrollLeft; 
                this.itemDescription =  this.vaslist[index].description;
                this.link= this.vaslist[index].name;
                this.itemDescriptionLink = this.vaslist[index].descriptionLink;
                var popUpDetails =  this.popupDetails;
                this.className = document.getElementsByClassName("flickity-button");

                for (var i = 0; i < this.className.length; i++) {
                    this.className[i].addEventListener('click', function(){
                       popUpDetails.style.display="none";
                    });
                }
                document.addEventListener("scroll",function(){
                   popUpDetails.style.display = 'none';
                });

                if(this.show){
                    this.show = !this.show;
                }
               
                if (!this.show){
                    this.popupDetails.style.display="block";
                    this.popupWidth=  this.popupValue.offsetWidth;
                    this.resolutionValue = window.matchMedia("(max-width: 767px)");
                    this.resolutionHigh = window.matchMedia("(min-width:768px) and (max-width: 1680px)");
                    this.resolutionLarge = window.matchMedia("(min-width:1681px) and (max-width: 2500px)");
                    this.resolutionXLarge = window.matchMedia("(min-width:2501px) and (max-width: 3400px)");
                    if (this.resolutionValue.matches) { 
                        this.popupValue.style.width="80%";
                        if ( this.divOffset < screen.width && this.divOffset > screen.width-this.popupWidth) {
                            if(this.divOffset > 200){
                                this.popupPosition = (this.divOffset - 530)+"px";
                                this.popupDetails.style.marginLeft= this.popupPosition;
                                this.pointerDetails.style.left="77%";
                            }
                            else {
                                this.popupPosition = (this.divOffset - 440)+"px";
                                this.popupDetails.style.marginLeft= this.popupPosition;
                                this.pointerDetails.style.left="48%";

                            }
                        } else{
                            this.popupPosition =(this.divOffset - 360)+"px";   
                            this.popupDetails.style.marginLeft= this.popupPosition; 
                            this.pointerDetails.style.left="21%";
                        }
                        
                    }
                    else if (this.resolutionHigh.matches) {
                        if ( this.divOffset < screen.width && this.divOffset > screen.width-this.popupWidth) {
                            if (screen.width == 1024){
                                this.popupValue.style.width="46%"
                            }
                            else {
                                this.popupValue.removeAttribute("style");
                            }
                            this.popupLocation =(this.divOffset - 440)+"px";                    
                            this.popupDetails.style.marginLeft= this.popupLocation;
                            if(screen.width < 1580){
                              this.pointerDetails.style.left="82%";
                            }
                            else {
                              this.pointerDetails.style.left="74%";
                            }
                        }
                        else  {
                            this.popupLocation = (this.divOffset - 130 )+"px";
                            this.popupDetails.style.marginLeft= this.popupLocation;
                            this.pointerDetails.style.left="15%";
                        }
                    }
                    else if(this.resolutionLarge.matches){
                        if (this.divOffset < screen.width && this.divOffset > screen.width-this.popupWidth) {
                            if (screen.width > 1680 && screen.width < 1920 ) {
                                this.popupValue.removeAttribute("style");
                            }
                            else {
                                this.popupValue.style.width="30%"
                            }
                            this.popupLocation =(this.divOffset - 550)+"px";                    
                            this.popupDetails.style.marginLeft= this.popupLocation;
                            this.pointerDetails.style.left="80%";
                        }
                        else  {
                            this.popupLocation = (this.divOffset - 280 )+"px";
                            this.popupDetails.style.marginLeft= this.popupLocation;
                            this.pointerDetails.style.left="20%";
                        }
                    }
                    else if(this.resolutionXLarge.matches){
                        if (this.divOffset < screen.width && this.divOffset < screen.width-this.popupWidth) {
                          if (this.divOffset > 1500) {
                            this.popupLocation = (this.divOffset - 900 )+"px";
                            this.popupDetails.style.marginLeft= this.popupLocation;
                            this.pointerDetails.style.left="77%";
                          }
                          else {
                            this.popupLocation = (this.divOffset - 620 )+"px";
                            this.popupDetails.style.marginLeft= this.popupLocation;
                            this.pointerDetails.style.left="22%"; 
                          }
                        }
                    }
                    else {
                        if (this.divOffset < screen.width && this.divOffset < screen.width-this.popupWidth) {
                            if (this.divOffset > 1700) {
                                this.popupLocation = (this.divOffset - 1340 )+"px";
                                this.popupDetails.style.marginLeft= this.popupLocation;
                                this.pointerDetails.style.left="73%";
                            }
                            else {
                                this.popupLocation = (this.divOffset - 1020 )+"px";
                                this.popupDetails.style.marginLeft= this.popupLocation;
                                this.pointerDetails.style.left="11%"; 
                            }
                        }
                    }
                    if(this.itemDescription != null){
                      document.getElementById("vasdescription").innerHTML=this.itemDescription;
                    }
                    else {
                      this.popupDetails.style.display="none";
                    }
                    this.readMoreLabel=document.getElementById("readmorelabel").value;
                    this.readMoreHereLabel=document.getElementById("readmoreherelabel").value;
                    document.getElementById("vaslink").innerHTML= this.readMoreLabel + " "+this.link + " "+ this.readMoreHereLabel;
                    document.getElementById("vaslink").href=this.itemDescriptionLink;
                    this.show = true;
                    }
                    else {
                    this.popupDetails.style.display="none";
                    this.show = false;
                    }
            }
        },
}
